import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Text, TextProps } from "@chakra-ui/react";
import { sharedProps } from "~/constants";

interface Props extends TextProps {
  children: ReactNode;
  onClick: () => void;
  to: string;
}

export const InternalLink: FC<Props> = ({
  children,
  onClick,
  to,
  ...props
}) => {
  return (
    <Text
      as={Link}
      color="white"
      onClick={onClick}
      size="md"
      to={to}
      {...sharedProps.link.hover}
      {...props}
    >
      {children}
    </Text>
  );
};
